import { repairPoisonedAssetCache } from "utils/asset-cache-repair.util";

// Indirection over the chunk-load recovery reload — jsdom's location is
// frozen, so callers that need unit tests mock this module instead.
//
// Recovery reloads to a cache-busted URL rather than a plain
// window.location.reload(): a plain reload re-requests the same route URL and
// can be served the SAME cached (browser/CDN/proxy) index.html, whose stale
// asset manifest still points at the missing hashed chunk — so the client
// never receives the new build and stays stuck on the old one (SN-18813). A
// unique query param changes the cache key, forcing a fresh document fetch.
// location.replace avoids leaving a throwaway history entry.
//
// Busting the document's URL does nothing for a chunk whose 404 is sitting in
// the HTTP cache, so any failed /assets/* request is re-fetched first
// (DEV-3172, asset-cache-repair.util.ts). A no-op when nothing has failed.
export const reloadPage = () => {
  void repairPoisonedAssetCache().finally(() => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("_cb", Date.now().toString(36));
      window.location.replace(url.toString());
    } catch {
      window.location.reload();
    }
  });
};

// Same seam, plain window.location.reload() — for callers that want an ordinary
// reload rather than the cache-busted one above (e.g. ENG-747's stale-build pill,
// whose first reload attempt is a plain refresh; it only escalates to the
// cache-busted `reloadPage` above if the plain one didn't pick up the new build).
export const plainReloadPage = () => {
  window.location.reload();
};
